import axios from 'axios';

let _history;
let unregisterResponse;

function handleResponseHeaders({ redirectto }, history) {
  if (redirectto) {
    _history.push(redirectto);
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  initInterceptors(history) {
    if (history && !_history) {
      _history = history;
    }
    unregisterResponse = axios.interceptors.response.use(
      (response) => {
        handleResponseHeaders(response.headers, _history);
        return response;
      },
      (err) => {
        handleResponseHeaders(err.response.headers);
        return Promise.reject(err);
      }
    );
  },
  clearInterceptors() {
    axios.interceptors.response.eject(unregisterResponse);
  }
};
